import Flickity from 'flickity-fade'

function DOMready(callback) {
  if (document.readyState != 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

DOMready(function () {
  const optionsFlkty = {
    cellAlign: 'center',
    prevNextButtons: true,
    wrapAround: true,
    pageDots: true,
    fade: true,
    autoPlay: 6000
  }

  const btnVideo = document.querySelectorAll('.text-with-img-slider__btn')
  const popupVideo = document.getElementById('popupVideo')
  function stopVideo() {
    popupVideo.pause()
    popupVideo.currentTime = 0
  }
  const section = document.querySelector('.text-with-img-slider')
  if (section == null) return

  const items = document.querySelectorAll('.text-with-img-slider__item')

  if (items.length > 0) {
    const wrap = document.querySelector('.text-with-img-slider__wrapper')

    new Flickity(wrap, optionsFlkty)
  }

  if (btnVideo.length > 0) {
    btnVideo.forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault()
        const overlay = document.querySelector('.overlay')
        overlay.style.display = 'block'
        popupVideo.play()
      })
    })

    document.addEventListener('click', function (e) {
      const overlay = document.querySelector('.overlay')

      if (e.target.closest(".text-with-img-slider__btn") != null) return
      if (e.target.closest("#popupVideo") != null) return

      overlay.style.display = 'none'
      stopVideo();
      event.stopPropagation();
    })
  }
})
